<i18n src="@/translations/EntryDisplay.json"></i18n>
<template>
  <div :class="['lex-entry', {small} ]">
    <h1 class="lex-title" v-if="title">{{ title }}</h1>
    <div class="lex-alternatives" v-if="!small && alternativesToShow.length">auch: {{
        alternativesToShow.join(', ')
      }}
    </div>
    <div v-if="!small && englishToShow.length" class="lex-more">{{ $t('EntryDisplay.englisch_label') }}:
      {{ englishToShow.join(', ') }}
    </div>
    <div v-if="!small && opposite" class="lex-more">{{ $t('EntryDisplay.opposite_label') }}: <span
      :data-to="opposite._meta.uid" class="crossref">{{ opposite.title }}</span></div>
    <component
      :class="['slice', slice.type]"
      :key="index"
      :slice="slice"
      :is="slices[slice.type]"
      @entryClicked="(val) => $emit('entryClicked', val)"
      v-for="(slice, index) in  body"/>
  </div>
</template>

<script>
import Content from "./slices/Content"
import Example from "./slices/Example"

//TODO use same like lexicon project FINDEV-2345

export default {
  name: "EntryDisplay",
  props: {
    entry: {},
    small: {
      type: Boolean
    }
  },
  data() {
    return {
      slices: {
        content: Content,
        example: Example
      }
    }
  },
  computed: {
    title() {
      return this.entry.title + this.abbreviation
    },
    abbreviation() {
      return this.entry.abbreviation ? ` (${this.entry.abbreviation})` : ''
    },
    body() {
      return this.entry.body
    },
    englishToShow() {
      if(!this.entry.alternatives){
        return []
      }
      const result = this.entry.alternatives.filter(a => a.alternative && a.show_in_description && a.alternativ_language === 'English')
        .map( a => a.alternative + ( a.alternativ_abbreviation ? ` (${a.alternativ_abbreviation})` : '') )
      if(this.entry.english){
        result.unshift(this.entry.english)
      }
      return result
    },
    alternativesToShow() {
      if(!this.entry.alternatives){
        return []
      }
      return this.entry.alternatives.filter(a => a.alternative && a.show_in_description && !a.alternativ_language)
        .map( a => a.alternative + ( a.alternativ_abbreviation ? ` (${a.alternativ_abbreviation})` : '') )
    },
    opposite() {
      return this.entry.opposite
    }
  },

}
</script>

<style scoped lang="scss">

.lex-entry{
  ::v-deep .paragraph{
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .lex-title{
    font-size: 28px;
  }

  .lex-alternatives{
    font-size: 16px;
  }

  .lex-more{
    font-size: 14px;
  }

  .lex-slice{
    &.content{
      font-size: 16px;
    }

    &.example{
      font-size: 14px;
    }
  }

  &.small{
    ::v-deep .paragraph{
      margin-top: 8px;
      margin-bottom: 8px;
    }

    .lex-title{
      font-size: 16px;
    }

    .lex-slice{
      &.content{
        font-size: 14px;
      }

      &.example{
        font-size: 15px;
      }
    }
  }
}


</style>
